import { render, staticRenderFns } from "./SettingsCreateCountry.vue?vue&type=template&id=5f8cd49e&scoped=true"
import script from "./SettingsCreateCountry.vue?vue&type=script&lang=js"
export * from "./SettingsCreateCountry.vue?vue&type=script&lang=js"
import style0 from "./SettingsCreateCountry.vue?vue&type=style&index=0&id=5f8cd49e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8cd49e",
  null
  
)

export default component.exports